export const INSTITUTIONS_LIST = [
  "FUT Babura",
  "FU Trans Daura",
  "Al-Qalam University",
  "Umaru Musa Yar'adua University (UMYU)",
  "Hassan Usman Katsina Polytechnic",
  "Federal University Dutsin-Ma (FUDMA)",
  "Federal Polytechnic Daura",
  "Isa Kaita College of Education Dutsinma",
  "Bayero University Kano (BUK)",
  "Ahmadu Bello University (ABU)",
  "Kaduna State University (KASU)",
  "Kano University of Science & Tech (KUST), Wudil",
  "Cherish College of Health Tech, Batsari",
  "University of Lagos (UNILAG)",
  "University of Ibadan (UI)",
  "Other / External Institution"
];

export const SECONDARY_SCHOOLS_LIST = INSTITUTIONS_LIST;

export const POPULAR_BANKS_LIST = [
  "Zenith Bank",
  "Keystone Bank",
  "United Bank for Africa (UBA)",
  "First Bank of Nigeria",
  "Access Bank",
  "Jaiz Bank",
  "Guaranty Trust Bank (GTBank)",
  "Fidelity Bank",
  "Stanbic IBTC Bank",
  "Union Bank of Nigeria",
  "Polaris Bank",
  "Sterling Bank",
  "Wema Bank",
  "Taj Bank",
  "Lotus Bank",
  "Kuda Bank",
  "OPay",
  "Moniepoint MFB"
];

export const STATES_LIST = [
  "Katsina",
  "Kaduna",
  "Kano",
  "Kebbi",
  "Jigawa",
  "Sokoto",
  "Zamfara",
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT Abuja",
  "Gombe",
  "Imo",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Taraba",
  "Yobe"
];

export const KATSINA_LGAS = [
  "Baure",
  "Daura",
  "Dutsi",
  "Zango",
  "Funtua",
  "Bakori",
  "Batagarawa",
  "Batsari",
  "Bindawa",
  "Charanchi",
  "Dan Musa",
  "Dandume",
  "Danja",
  "Faskari",
  "Ingawa",
  "Jibia",
  "Kafur",
  "Kaita",
  "Kankara",
  "Kankia",
  "Katsina",
  "Kurfi",
  "Kusada",
  "Mai'Adua",
  "Malumfashi",
  "Mani",
  "Mashi",
  "Matazu",
  "Musawa",
  "Rimi",
  "Sabuwa",
  "Safana",
  "Sandamu",
  "Other"
];

export const ACADEMIC_SESSIONS_LIST = [
  "2025/2026",
  "2024/2025",
  "2023/2024",
  "2026/2027"
];

export const LEVELS_LIST = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600"
];

export const SCHOLARSHIP_DURATIONS_LIST = [
  "1 yr",
  "2 yrs",
  "3 yrs",
  "4 yrs",
  "5 yrs",
  "6 yrs"
];

export function normalizeScholarship(s, index = 0) {
  const student_name = (
    s.student_name ||
    s.fullName ||
    s.name ||
    `${s.firstName || ""} ${s.lastName || ""}`.trim() ||
    `Scholar ${index + 1}`
  ).trim();

  const tuition_or_reg_fees = Number(
    s.tuition_or_reg_fees ??
    s.schoolFeesAmount ??
    (s.kind === "School Fees Only" ? s.amount : Math.round((Number(s.amount) || 0) * 0.6))
  ) || 0;

  const allowance = Number(
    s.allowance ??
    s.allowanceAmount ??
    (s.kind === "Allowance Only" ? s.amount : Math.max(0, (Number(s.amount) || 0) - tuition_or_reg_fees))
  ) || 0;

  const total_amount = (tuition_or_reg_fees + allowance) > 0
    ? (tuition_or_reg_fees + allowance)
    : Number(s.total_amount ?? s.amount) || 150000;

  const institution_name = s.institution_name || s.school || "FUT Babura";
  const registration_number = s.registration_number || s.regNo || `SAT/BIO/24/${String(index + 10).padStart(4, "0")}`;
  const academic_session = s.academic_session || "2025/2026";
  const state_of_origin = s.state_of_origin || "Katsina";
  const lga = s.lga || "Zango";
  const course = s.course || "B.Sc Biology Sci";
  const level = String(s.level || "200").replace(/\D/g, "") || "200";
  const scholarship_duration = s.scholarship_duration || "4 yrs";
  const year_of_entry = Number(s.year_of_entry) || 2024;
  const year_of_graduation = Number(s.year_of_graduation) || 2028;
  const bank_name = s.bank_name || s.bankName || "Zenith Bank";
  const account_number = s.account_number || s.bankAccount || "1023456789";
  const remark = s.remark || "Active scholar in good academic standing";
  const serial_number = s.serial_number || s.serialNumber || `SCH-2025-${String(index + 1).padStart(3, "0")}`;

  const nameParts = student_name.split(" ");
  const firstName = s.firstName || nameParts[0] || "Scholar";
  const lastName = s.lastName || nameParts.slice(1).join(" ") || "";

  return {
    ...s,
    id: s.id || `sch_${Date.now()}_${index}`,
    serial_number,
    academic_session,
    institution_name,
    student_name,
    registration_number,
    state_of_origin,
    lga,
    course,
    level,
    scholarship_duration,
    year_of_entry,
    year_of_graduation,
    tuition_or_reg_fees,
    allowance,
    total_amount,
    bank_name,
    account_number,
    remark,

    // Backward-compatibility properties
    firstName,
    lastName,
    name: student_name,
    fullName: student_name,
    school: institution_name,
    amount: total_amount,
    schoolFeesAmount: tuition_or_reg_fees,
    allowanceAmount: allowance,
    bankName: bank_name,
    bankAccount: account_number,
    status: s.status || "Active",
    totalDisbursed: Number(s.totalDisbursed) || 0,
    createdDate: s.createdDate || "2025-01-15",
    nextPaymentDate: s.nextPaymentDate || "2026-09-01",
    endPeriod: s.endPeriod || "2028-06-30",
    frequency: s.frequency || "Monthly",
    kind: s.kind || "School Fees with Allowance"
  };
}

export const DEFAULT_MOCK_SCHOLARSHIPS = [
  {
    id: "sch-001",
    serial_number: "SCH-2025-001",
    academic_session: "2025/2026",
    institution_name: "FUT Babura",
    student_name: "Amina Bello",
    registration_number: "SAT/BIO/24/0022",
    state_of_origin: "Katsina",
    lga: "Zango",
    course: "B.Sc Biology Sci",
    level: "200",
    scholarship_duration: "4 yrs",
    year_of_entry: 2024,
    year_of_graduation: 2028,
    tuition_or_reg_fees: 110000,
    allowance: 70000,
    total_amount: 180000,
    bank_name: "Zenith Bank",
    account_number: "1012345678",
    remark: "Active scholar in good academic standing.",
    status: "Active",
    totalDisbursed: 1440000,
    createdDate: "2024-09-01",
    createdDateFmt: "01 Sep 2024",
    avatarClass: "bg-light-success text-success",
    initials: "AB"
  },
  {
    id: "sch-002",
    serial_number: "SCH-2025-002",
    academic_session: "2025/2026",
    institution_name: "FU Trans Daura",
    student_name: "Ibrahim Musa Daura",
    registration_number: "FUTD/SE/24/0115",
    state_of_origin: "Katsina",
    lga: "Daura",
    course: "Software Engr",
    level: "300",
    scholarship_duration: "4 yrs",
    year_of_entry: 2023,
    year_of_graduation: 2027,
    tuition_or_reg_fees: 180000,
    allowance: 80000,
    total_amount: 260000,
    bank_name: "Keystone Bank",
    account_number: "2087654321",
    remark: "Dean's honor roll in Software Engineering.",
    status: "Active",
    totalDisbursed: 2080000,
    createdDate: "2023-10-01",
    createdDateFmt: "01 Oct 2023",
    avatarClass: "bg-light-primary text-primary",
    initials: "IM"
  },
  {
    id: "sch-003",
    serial_number: "SCH-2025-003",
    academic_session: "2025/2026",
    institution_name: "Al-Qalam University",
    student_name: "Fatima Kabir Baure",
    registration_number: "AHS/NUS/24/1010",
    state_of_origin: "Katsina",
    lga: "Baure",
    course: "BNSc Nursing",
    level: "200",
    scholarship_duration: "5 yrs",
    year_of_entry: 2024,
    year_of_graduation: 2029,
    tuition_or_reg_fees: 170000,
    allowance: 80000,
    total_amount: 250000,
    bank_name: "Jaiz Bank",
    account_number: "0765432198",
    remark: "Nursing clinical practicals and board grant approved.",
    status: "Active",
    totalDisbursed: 2000000,
    createdDate: "2024-01-15",
    createdDateFmt: "15 Jan 2024",
    avatarClass: "bg-light-warning text-warning",
    initials: "FK"
  },
  {
    id: "sch-004",
    serial_number: "SCH-2025-004",
    academic_session: "2025/2026",
    institution_name: "Umaru Musa Yar'adua University (UMYU)",
    student_name: "Usman Sani Dutsi",
    registration_number: "UMYU/CSC/24/0082",
    state_of_origin: "Katsina",
    lga: "Dutsi",
    course: "B.Sc Computer Science",
    level: "100",
    scholarship_duration: "4 yrs",
    year_of_entry: 2025,
    year_of_graduation: 2029,
    tuition_or_reg_fees: 90000,
    allowance: 60000,
    total_amount: 150000,
    bank_name: "First Bank of Nigeria",
    account_number: "3124567890",
    remark: "Freshman STEM awardee from Dutsi LGA.",
    status: "Active",
    totalDisbursed: 600000,
    createdDate: "2025-01-10",
    createdDateFmt: "10 Jan 2025",
    avatarClass: "bg-light-info text-info",
    initials: "US"
  },
  {
    id: "sch-005",
    serial_number: "SCH-2025-005",
    academic_session: "2025/2026",
    institution_name: "Federal University Dutsin-Ma (FUDMA)",
    student_name: "Maryam Lawal Funtua",
    registration_number: "FUDMA/BCH/23/0441",
    state_of_origin: "Katsina",
    lga: "Funtua",
    course: "B.Sc Biochemistry",
    level: "300",
    scholarship_duration: "4 yrs",
    year_of_entry: 2023,
    year_of_graduation: 2027,
    tuition_or_reg_fees: 120000,
    allowance: 60000,
    total_amount: 180000,
    bank_name: "United Bank for Africa (UBA)",
    account_number: "1023456789",
    remark: "Women in STEM community scholarship.",
    status: "Active",
    totalDisbursed: 1440000,
    createdDate: "2023-09-01",
    createdDateFmt: "01 Sep 2023",
    avatarClass: "bg-light-danger text-danger",
    initials: "ML"
  },
  {
    id: "sch-006",
    serial_number: "SCH-2025-006",
    academic_session: "2025/2026",
    institution_name: "Hassan Usman Katsina Polytechnic",
    student_name: "Aliyu Umar Zango",
    registration_number: "HUK/CE/24/0034",
    state_of_origin: "Katsina",
    lga: "Zango",
    course: "Civil Engineering",
    level: "200",
    scholarship_duration: "3 yrs",
    year_of_entry: 2024,
    year_of_graduation: 2027,
    tuition_or_reg_fees: 75000,
    allowance: 45000,
    total_amount: 120000,
    bank_name: "Access Bank",
    account_number: "0034567891",
    remark: "ND Civil Engineering technical scholarship.",
    status: "Active",
    totalDisbursed: 720000,
    createdDate: "2024-03-01",
    createdDateFmt: "01 Mar 2024",
    avatarClass: "bg-light-success text-success",
    initials: "AU"
  },
  {
    id: "sch-007",
    serial_number: "SCH-2025-007",
    academic_session: "2025/2026",
    institution_name: "FU Trans Daura",
    student_name: "Zainab Sadiq Daura",
    registration_number: "FUTD/LOG/23/0078",
    state_of_origin: "Katsina",
    lga: "Daura",
    course: "Transport & Logistics Mgt",
    level: "300",
    scholarship_duration: "4 yrs",
    year_of_entry: 2023,
    year_of_graduation: 2027,
    tuition_or_reg_fees: 140000,
    allowance: 60000,
    total_amount: 200000,
    bank_name: "Zenith Bank",
    account_number: "5081234567",
    remark: "Verified Daura community scholar in good standing.",
    status: "Active",
    totalDisbursed: 1600000,
    createdDate: "2024-09-01",
    createdDateFmt: "01 Sep 2024",
    avatarClass: "bg-light-primary text-primary",
    initials: "ZS"
  },
  {
    id: "sch-008",
    serial_number: "SCH-2025-008",
    academic_session: "2025/2026",
    institution_name: "FUT Babura",
    student_name: "Suleiman Bello",
    registration_number: "FUTB/ME/24/0091",
    state_of_origin: "Jigawa",
    lga: "Babura",
    course: "Mechanical Engineering",
    level: "200",
    scholarship_duration: "5 yrs",
    year_of_entry: 2024,
    year_of_graduation: 2029,
    tuition_or_reg_fees: 130000,
    allowance: 70000,
    total_amount: 200000,
    bank_name: "First Bank of Nigeria",
    account_number: "2114567890",
    remark: "Merit-based university mechanical engineering award.",
    status: "Active",
    totalDisbursed: 1200000,
    createdDate: "2024-11-01",
    createdDateFmt: "01 Nov 2024",
    avatarClass: "bg-light-success text-success",
    initials: "SB"
  },
  {
    id: "sch-009",
    serial_number: "SCH-2025-009",
    academic_session: "2025/2026",
    institution_name: "Ahmadu Bello University (ABU)",
    student_name: "Aisha Abubakar",
    registration_number: "ABU/PHM/22/0319",
    state_of_origin: "Kaduna",
    lga: "Zaria",
    course: "B.Pharmacy",
    level: "400",
    scholarship_duration: "5 yrs",
    year_of_entry: 2022,
    year_of_graduation: 2027,
    tuition_or_reg_fees: 160000,
    allowance: 90000,
    total_amount: 250000,
    bank_name: "Keystone Bank",
    account_number: "0229876543",
    remark: "Pharmacy professional licensure track support.",
    status: "Active",
    totalDisbursed: 2250000,
    createdDate: "2023-10-01",
    createdDateFmt: "01 Oct 2023",
    avatarClass: "bg-light-info text-info",
    initials: "AA"
  },
  {
    id: "sch-010",
    serial_number: "SCH-2025-010",
    academic_session: "2025/2026",
    institution_name: "Bayero University Kano (BUK)",
    student_name: "Bello Mustapha",
    registration_number: "BUK/MBBS/21/0088",
    state_of_origin: "Kano",
    lga: "Dala",
    course: "MBBS Medicine & Surgery",
    level: "500",
    scholarship_duration: "6 yrs",
    year_of_entry: 2021,
    year_of_graduation: 2027,
    tuition_or_reg_fees: 220000,
    allowance: 100000,
    total_amount: 320000,
    bank_name: "Jaiz Bank",
    account_number: "0812345670",
    remark: "Medical student clinical internship and materials support.",
    status: "Active",
    totalDisbursed: 3200000,
    createdDate: "2024-09-15",
    createdDateFmt: "15 Sep 2024",
    avatarClass: "bg-light-warning text-warning",
    initials: "BM"
  },
  {
    id: "sch-011",
    serial_number: "SCH-2025-011",
    academic_session: "2025/2026",
    institution_name: "Al-Qalam University",
    student_name: "Salisu Haruna",
    registration_number: "AQU/ACC/24/0201",
    state_of_origin: "Katsina",
    lga: "Katsina",
    course: "B.Sc Accounting",
    level: "200",
    scholarship_duration: "4 yrs",
    year_of_entry: 2024,
    year_of_graduation: 2028,
    tuition_or_reg_fees: 115000,
    allowance: 55000,
    total_amount: 170000,
    bank_name: "Zenith Bank",
    account_number: "3098765432",
    remark: "Recommended for continuous funding.",
    status: "Active",
    totalDisbursed: 850000,
    createdDate: "2025-03-01",
    createdDateFmt: "01 Mar 2025",
    avatarClass: "bg-light-primary text-primary",
    initials: "SH"
  },
  {
    id: "sch-012",
    serial_number: "SCH-2025-012",
    academic_session: "2025/2026",
    institution_name: "FUT Babura",
    student_name: "Hauwa Mohammed",
    registration_number: "FUTB/CEN/23/0045",
    state_of_origin: "Kebbi",
    lga: "Birnin Kebbi",
    course: "Chemical Engineering",
    level: "300",
    scholarship_duration: "5 yrs",
    year_of_entry: 2023,
    year_of_graduation: 2028,
    tuition_or_reg_fees: 140000,
    allowance: 80000,
    total_amount: 220000,
    bank_name: "Guaranty Trust Bank (GTBank)",
    account_number: "0156789012",
    remark: "Women in engineering scholarship recipient.",
    status: "Active",
    totalDisbursed: 1320000,
    createdDate: "2024-02-01",
    createdDateFmt: "01 Feb 2024",
    avatarClass: "bg-light-success text-success",
    initials: "HM"
  }
].map((s, idx) => normalizeScholarship(s, idx));

export const DEFAULT_MOCK_PAYMENTS = [
  {
    id: "pay-101",
    scholarshipId: "sch-001",
    studentName: "Amina Bello",
    amount: 180000,
    date: "2026-08-01T09:30:00.000Z",
    reference: "SCH-PAY-99281",
    method: "Bank Transfer",
    bankName: "Zenith Bank",
    bankAccount: "1012345678",
    status: "Completed",
    notes: "August 2026 Tuition Fees & Monthly Allowance"
  },
  {
    id: "pay-102",
    scholarshipId: "sch-001",
    studentName: "Amina Bello",
    amount: 180000,
    date: "2026-07-01T10:15:00.000Z",
    reference: "SCH-PAY-88123",
    method: "Bank Transfer",
    bankName: "Zenith Bank",
    bankAccount: "1012345678",
    status: "Completed",
    notes: "July 2026 Semester Grant Disbursement"
  },
  {
    id: "pay-103",
    scholarshipId: "sch-002",
    studentName: "Ibrahim Musa Daura",
    amount: 260000,
    date: "2026-07-15T08:45:00.000Z",
    reference: "SCH-PAY-66521",
    method: "Electronic Transfer",
    bankName: "Keystone Bank",
    bankAccount: "2087654321",
    status: "Completed",
    notes: "Second Semester 2025/2026 Tuition Fees & Allowance"
  },
  {
    id: "pay-104",
    scholarshipId: "sch-003",
    studentName: "Fatima Kabir Baure",
    amount: 250000,
    date: "2026-08-01T12:00:00.000Z",
    reference: "SCH-PAY-55198",
    method: "Bank Transfer",
    bankName: "Jaiz Bank",
    bankAccount: "0765432198",
    status: "Completed",
    notes: "Nursing Practicals, Tuition & Allowance Support"
  },
  {
    id: "pay-105",
    scholarshipId: "sch-004",
    studentName: "Usman Sani Dutsi",
    amount: 150000,
    date: "2026-08-01T14:30:00.000Z",
    reference: "SCH-PAY-44091",
    method: "Bank Transfer",
    bankName: "First Bank of Nigeria",
    bankAccount: "3124567890",
    status: "Completed",
    notes: "First Semester 2025/2026 Tuition & Reg Fees"
  },
  {
    id: "pay-106",
    scholarshipId: "sch-005",
    studentName: "Maryam Lawal Funtua",
    amount: 180000,
    date: "2026-08-01T15:00:00.000Z",
    reference: "SCH-PAY-33182",
    method: "Bank Transfer",
    bankName: "United Bank for Africa (UBA)",
    bankAccount: "1023456789",
    status: "Completed",
    notes: "Biochemistry Practicals & Academic Session Allowance"
  }
];
